import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Locked: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 14 18" {...props}>
    <path d="M12.232 5.711h-.82V4.088c0-2.24-1.838-4.058-4.103-4.058-2.264 0-4.102 1.819-4.102 4.058v1.623h-.82c-.903 0-1.643.73-1.643 1.622v8.116c0 .892.74 1.623 1.642 1.623h9.846c.902 0 1.64-.73 1.64-1.623V7.333c0-.892-.738-1.622-1.64-1.622zM7.31 13.014c-.902 0-1.64-.73-1.64-1.623 0-.892.738-1.623 1.64-1.623.903 0 1.641.73 1.641 1.623s-.738 1.623-1.641 1.623zm2.543-7.303H4.766V4.088c0-1.388 1.14-2.516 2.543-2.516 1.404 0 2.543 1.128 2.543 2.516v1.623z" />
  </Icon>
);
